// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3075de56] .el-pagination {\n  margin-top: 20px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
